import ApiService from './ApiService'

export const apiListCollectionPoints = () => ApiService.get('/admin/list/collection-points')
export const apiListMaterials = () => ApiService.get('/admin/list/materials')
export const apiListAffiliates = () => ApiService.get('/admin/list/affiliates')
export const apiListStorages = () => ApiService.get('/admin/list/storages')
export const apiListProjects = id => ApiService.get(`/admin/list/projects/${id}`)
export const apiListBatchRejectTypes = () => ApiService.get('/admin/list/batch-reject-types')
export const apiListUsers = () => ApiService.get(`/admin/list/users`)

export const apiAdminsList = data => ApiService.get('/admin/admins', data)
export const apiAdminsView = id => ApiService.get(`/admin/admins/${id}`)
export const apiAdminsForm = (id, data) => ApiService.post(`/admin/admins${id ? `/${id}` : ''}`, data)
export const apiAdminsStatus = id => ApiService.post(`/admin/admins/${id}/status`)
export const apiAdminsVerified = id => ApiService.post(`/admin/admins/${id}/verified`)
export const apiSendMail = data => ApiService.post('/admin/send-mail', data)

export const apiCollectionPointsList = data => ApiService.get('/admin/collection-points', data)
export const apiCollectionPointsView = id => ApiService.get(`/admin/collection-points/${id}`)
export const apiCollectionPointsForm = (id, data) => ApiService.post(`/admin/collection-points${id ? `/${id}` : ''}`, data)
export const apiCollectionPointsStatus = id => ApiService.post(`/admin/collection-points/${id}/status`)
export const apiCollectionPointsExport = data => ApiService.get(`/admin/collection-points-export`, data)

export const apiCollectionPointBagRequestsList = data => ApiService.get('/admin/collection-point/bag-requests', data)
export const apiCollectionPointBagRequestsView = id => ApiService.get(`/admin/collection-point/bag-requests/${id}`)
export const apiCollectionPointBagRequestsForm = (id, data) =>
    ApiService.post(`/admin/collection-point/bag-requests${id ? `/${id}` : ''}`, data)
export const apiCollectionPointBagRequestsStatus = (id, data) =>
    ApiService.post(`/admin/collection-point/bag-requests/${id}/status`, data)
export const apiCollectionPointBagRequestsExport = data => ApiService.get(`/admin/collection-point/bag-requests-export`, data)

export const apiAffiliatesList = data => ApiService.get('/admin/affiliates', data)
export const apiAffiliatesView = id => ApiService.get(`/admin/affiliates/${id}`)
export const apiAffiliatesForm = (id, data) => ApiService.post(`/admin/affiliates${id ? `/${id}` : ''}`, data)
export const apiAffiliatesStatus = id => ApiService.post(`/admin/affiliates/${id}/status`)
export const apiAffiliatesExport = data => ApiService.get(`/admin/affiliates-export`, data)

export const apiStoragesList = data => ApiService.get('/admin/storages', data)
export const apiStoragesView = id => ApiService.get(`/admin/storages/${id}`)
export const apiStoragesForm = (id, data) => ApiService.post(`/admin/storages${id ? `/${id}` : ''}`, data)
export const apiStoragesStatus = id => ApiService.post(`/admin/storages/${id}/status`)
export const apiStoragesExport = data => ApiService.get(`/admin/storages-export`, data)

export const apiUsersList = data => ApiService.get('/admin/users', data)
export const apiUsersView = id => ApiService.get(`/admin/users/${id}`)
export const apiUsersForm = (id, data) => ApiService.post(`/admin/users${id ? `/${id}` : ''}`, data)
export const apiUsersStatus = id => ApiService.post(`/admin/users/${id}/status`)
export const apiUsersVerified = id => ApiService.post(`/admin/users/${id}/verified`)
export const apiUsersExport = data => ApiService.get(`/admin/users-export`, data)

export const apiProjectsList = data => ApiService.get('/admin/projects', data)
export const apiProjectsView = id => ApiService.get(`/admin/projects/${id}`)
export const apiProjectsForm = (id, data) => ApiService.post(`/admin/projects${id ? `/${id}` : ''}`, data)
export const apiProjectsStatus = id => ApiService.post(`/admin/projects/${id}/status`)
export const apiProjectsExport = data => ApiService.get(`/admin/projects-export`, data)

export const apiBinBoxList = data => ApiService.get('/admin/bin-box', data)
export const apiBinBoxExport = data => ApiService.get(`/admin/bin-box-export`, data)
export const apiBinBagsList = data => ApiService.get('/admin/bin-bags', data)
export const apiBinBagsExport = data => ApiService.get(`/admin/bin-bags-export`, data)

export const apiProjectBagDropsList = data => ApiService.get('/admin/project-bag-drops', data)
export const apiProjectBagDropsView = id => ApiService.get(`/admin/project-bag-drops/${id}`)
export const apiProjectBagDropsForm = (id, data) => ApiService.post(`/admin/project-bag-drops${id ? `/${id}` : ''}`, data)
export const apiProjectBagDropsStatus = id => ApiService.post(`/admin/project-bag-drops/${id}/status`)
export const apiProjectBagDropsExport = data => ApiService.get(`/admin/project-bag-drops-export`, data)

export const apiPickupsList = data => ApiService.get('/admin/pickups', data)
export const apiPickupsView = id => ApiService.get(`/admin/pickups/${id}`)
export const apiPickupsForm = (id, data) => ApiService.post(`/admin/pickups${id ? `/${id}` : ''}`, data)
export const apiPickupsStatus = (id, data) => ApiService.post(`/admin/pickups/${id}/status`, data)
export const apiPickupsExport = data => ApiService.get(`/admin/pickups-export`, data)

export const apiPalletsList = data => ApiService.get('/admin/pallets', data)
export const apiDispatchesList = data => ApiService.get('/admin/dispatches', data)
export const apiDispatchesView = id => ApiService.get(`/admin/dispatches/${id}`)
export const apiDispatchesForm = (id, data) => ApiService.post(`/admin/dispatches${id ? `/${id}` : ''}`, data)
export const apiDispatchesStatus = (id, data) => ApiService.post(`/admin/dispatches/${id}/status`, data)
export const apiDispatchesExport = data => ApiService.get(`/admin/dispatches-export`, data)

export const apiAffiliateRejectedMaterialsList = data => ApiService.get('/admin/affiliate-rejected-materials', data)
export const apiAffiliateRejectedMaterialsView = id => ApiService.get(`/admin/affiliate-rejected-materials/${id}`)
export const apiAffiliateRejectedMaterialsForm = (id, data) =>
    ApiService.post(`/admin/affiliate-rejected-materials${id ? `/${id}` : ''}`, data)
export const apiAffiliateRejectedMaterialsExport = data => ApiService.get(`/admin/affiliate-rejected-materials-export`, data)

export const apiMaterialsList = data => ApiService.get('/admin/materials', data)
export const apiMaterialsView = id => ApiService.get(`/admin/materials/${id}`)
export const apiMaterialsForm = (id, data) => ApiService.post(`/admin/materials${id ? `/${id}` : ''}`, data)
export const apiMaterialsStatus = id => ApiService.post(`/admin/materials/${id}/status`)

export const apiBatchRejectTypesList = data => ApiService.get('/admin/batch-reject-types', data)
export const apiBatchRejectTypesView = id => ApiService.get(`/admin/batch-reject-types/${id}`)
export const apiBatchRejectTypesForm = (id, data) => ApiService.post(`/admin/batch-reject-types${id ? `/${id}` : ''}`, data)
export const apiBatchRejectTypesStatus = id => ApiService.post(`/admin/batch-reject-types/${id}/status`)

export const apiSettingsList = data => ApiService.get('/admin/settings', data)
export const apiSettingsView = id => ApiService.get(`/admin/settings/${id}`)
export const apiSettingsForm = (id, data) => ApiService.post(`/admin/settings${id ? `/${id}` : ''}`, data)

export const apiFileUploadsList = data => ApiService.get('/admin/file-uploads', data)
export const apiFileUploadsView = id => ApiService.get(`/admin/file-uploads/${id}`)
export const apiFileUploadsForm = (id, data) => ApiService.post(`/admin/file-uploads${id ? `/${id}` : ''}`, data)
export const apiFileUploadsStatus = id => ApiService.post(`/admin/file-uploads/${id}/status`)

export const apiContactsList = data => ApiService.get('/admin/contacts', data)
export const apiContactsView = id => ApiService.get(`/admin/contacts/${id}`)
export const apiContactsStatus = (id, data) => ApiService.post(`/admin/contacts/${id}/status`, data)

export const apiMemberProductsList = data => ApiService.get('/admin/member-products', data)
export const apiMemberProductsView = id => ApiService.get(`/admin/member-products/${id}`)
export const apiMemberProductsForm = (id, data) => ApiService.post(`/admin/member-products${id ? `/${id}` : ''}`, data)
export const apiMemberProductsStatus = id => ApiService.post(`/admin/member-products/${id}/status`)

export const apiCollectionPointBagDistributionList = data =>
    ApiService.get('/admin/report/collection-point-bag-distribution', data)
export const apiCollectionPointBagDistributionExport = data =>
    ApiService.get('/admin/report/collection-point-bag-distribution-export', data)

export const apiProjectList = data => ApiService.get('/admin/report/project', data)
export const apiProjectExport = data => ApiService.get('/admin/report/project-export', data)

export const apiAnnouncementsList = data => ApiService.get('/admin/announcements', data)
export const apiAnnouncementsView = id => ApiService.get(`/admin/announcements/${id}`)
export const apiAnnouncementsForm = (id, data) => ApiService.post(`/admin/announcements${id ? `/${id}` : ''}`, data)
export const apiAnnouncementsStatus = (id, data) => ApiService.post(`/admin/announcements/${id}/status`, data)
